import React, { createContext, useContext } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { PlayerSizeContextType } from '../types';

export interface PlayerSizeProviderProps {
  children?: React.ReactNode;
}

const PlayerSizeContext = createContext<PlayerSizeContextType>({
  height: 0,
  width: 0,
});

export const PlayerSizeProvider: React.FC<PlayerSizeProviderProps> = ({
  children,
}) => {
  const { height = 0, width = 0, ref } = useResizeDetector();

  const child = React.Children.only(children);

  return (
    <PlayerSizeContext.Provider value={{ height, width }}>
      {React.isValidElement(child) &&
        React.cloneElement(child as React.ReactElement, { ref })}
    </PlayerSizeContext.Provider>
  );
};

export function usePlayerSize() {
  return useContext(PlayerSizeContext);
}
